import React from 'react';
import {
  Loading as PiggybankLoading,
  Heading,
  Paragraph,
  withTrackPage,
} from '@piggybank/core';

import nls from './nls/Loading';
import { createTranslator } from '~/lib/nls-helper';

const NLS = createTranslator(nls);

const Loading = props => (
  <PiggybankLoading
    textMap={{ loading: NLS`Wait a minute` }}
    {...props}
  >
    <Heading level={3}>{NLS`Wait a minute`}</Heading>
    <Paragraph>
      {NLS`Please do not update or reload this screen`}
    </Paragraph>
  </PiggybankLoading>
);

export default withTrackPage('processing', 'component')(Loading);
